<template>
  <div class="">
    <el-dialog
      :visible.sync="getShow"
      append-to-body
      class="contactItem-dialog"
      :show-close="false"
    >
      <div class="contactItem-dialog-top">
        <div class="contactItem-dialog-topLeft">
          <span> 立即获取适合您的互联网智能化解决方案</span>
          <div class="photo">
            <span>可直接拨打电话</span>
            <span style="color:#E1251A">186-3037-6696</span>
          </div>
        </div>
        <div class="contactItem-dialog-topRight">
          <span class="el-icon-close" @click="getShow = false"></span>
        </div>
      </div>
      <div class="contactItem-dialog-form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="公司名称：" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请填写您的公司名称或负责人名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              placeholder="请填写您的联系方式："
            ></el-input>
          </el-form-item>
          <el-form-item label="咨询主题：" prop="theme">
            <el-input
              v-model="ruleForm.theme"
              placeholder="请填写您的咨询主题"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作邮箱：">
            <el-input
              v-model="ruleForm.email"
              placeholder="请填写您的邮箱地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="咨询内容：">
            <el-input
              type="textarea"
              v-model="ruleForm.content"
              placeholder="请填写您要咨询的具体内容"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <button type="button" @click="submitForm('ruleForm')">
              立即咨询
            </button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="show = false"
          >确 定</el-button
        >
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ZXDialog",
  // props: {
  //   dialogShow: {
  //     type: Boolean
  //   }
  // },
  data() {
    return {
      getShow: false,
      ruleForm: {
        name: "",
        phone: "",
        theme: "",
        email: "",
        content: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写您的公司名称或负责人名称",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请填写您的联系方式：", trigger: "blur" },
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请填写正确的手机号"
          }
        ],
        theme: [
          { required: true, message: "请填写您的咨询主题", trigger: "blur" }
        ]
      }
    };
  },
  // watch: {
  //   dialogShow(val) {
  //     console.log(val);
  //     this.getShow = val;
  //   }
  // },
  methods: {
    parentHandleclick() {
      this.getShow = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post("index/common/add_consult", this.ruleForm)
            .then(res => {
              // console.log(res.status);
              if (res.status == 200) {
                this.ruleForm = {};
                // console.log(res.data.msg);
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.getShow = false;
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style scoped>
.contactItem-dialog >>> .el-dialog {
  width: 1026px;
  /* height: 630px; */
  background-image: url("~../assets/zxBox-banner.png");
  background-repeat: no-repeat;
  background-size: cover;
  /* background: #e7ecf3; */
  /* border: 1px solid #ffffff; */
  box-shadow: 0px 30px 60px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 61px 44px 48px;
}
.contactItem-dialog >>> .el-dialog__header {
  padding: 0;
}
.contactItem-dialog >>> .el-dialog__body {
  padding: 0;
}
.consultingService {
  height: 664px;
  background-image: url("~../assets/zxBox-banner.png");
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 79px;
}
.contactItem-dialog-top {
  margin-bottom: 43px;
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
}
.contactItem-dialog-top .contactItem-dialog-topLeft span {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #00000c;
  display: block;
  margin-bottom: 15px;
}
.contactItem-dialog-top .contactItem-dialog-topLeft .photo {
  display: flex;
}
.contactItem-dialog-top .contactItem-dialog-topLeft .photo > span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #454647;
}
.contactItem-dialog-topRight > span {
  font-size: 24px;
  color: #595959;
  cursor: pointer;
}

.contactItem-dialog-form .el-form {
  display: flex;
  flex-wrap: wrap;
}
.contactItem-dialog-form .el-form .el-form-item {
  width: 47.5%;
  margin-right: 30px;
}
.contactItem-dialog-form .el-form .el-form-item:nth-child(2n) {
  margin-right: 0px;
}
.contactItem-dialog-form .el-form .el-form-item:nth-child(5) {
  width: 100%;
}
.contactItem-dialog-form .el-form .el-form-item:nth-child(6) {
  width: 100px;
  margin: 0 auto;
}
.contactItem-dialog-form .el-form .el-form-item:nth-child(6) button {
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 34px;
  margin-top: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/ZXDialog.vue